module.exports = __webpack_public_path__ + "img/explosion-2.ed1dec2a.png";